import { API_V1 } from "../config/main-axios";

class Dashboard {
  getFinancialChart(params) {
    return API_V1.get("/dashboard/financial-chart/chart/", {params: params})
  }

  getUserChart(params) {
    return API_V1.get("/dashboard/user-chart/chart/", {params: params})
  }
  
  getChildCount() {
    return API_V1.get("/api/dashbord/count/")
  }
}

export default new Dashboard();